import { Link } from 'react-router-dom';
import { novels } from '@/mocks/novels';
import { formatCount, truncate } from '@/utils/format';

const hottest = [...novels].sort((a, b) => b.views - a.views).slice(0, 6);

export default function HotRecommend() {
  return (
    <section className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
      <div className="mb-7">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          热门推荐榜
        </h2>
        <p className="mt-2 text-sm text-foreground-500">根据阅读热度实时排行的口碑佳作</p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {hottest.map((novel, i) => (
          <Link
            key={novel.id}
            to={`/detail/${novel.id}`}
            className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-all hover:-translate-y-1 hover:border-accent-300"
          >
            <span
              className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-lg font-bold ${
                i < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-600'
              }`}
            >
              {i + 1}
            </span>
            <div className="flex min-w-0 flex-1 gap-3">
              <div className="h-20 w-[60px] shrink-0 overflow-hidden rounded bg-background-200">
                <img
                  src={novel.cover}
                  alt={`${novel.title}封面`}
                  title={`${novel.title}小说封面`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-accent-600">
                  {novel.title}
                </h3>
                <p className="mt-1 truncate text-xs text-foreground-500">
                  {novel.author} · {novel.category}
                </p>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                  {truncate(novel.intro, 42)}
                </p>
                <p className="mt-1.5 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatCount(novel.views)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500"></i>
                    {novel.rating.toFixed(1)}
                  </span>
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}